export const common =  {
    '请求延时': 'Délai de requête',
    '操作成功': 'Opération réussie',
    '暂无数据': 'Aucune donnée',
    '请输入': 'Veuillez entrer',
    'copyok': 'Copie réussie',
    'copyerror': 'Échec de la copie',
  };

 export const tableList = {
    '持仓': 'Position',
    '仓位': 'Poste',
    '跟单交易量':'Volume de trading copié',
    '跟单总交易量':'Volume total copié',
    '用户昵称':'Pseudonyme',
    '当前委托': 'Ordre actuel',
    '当前计划': 'Plan actuel',
    '历史仓位': 'Historique des postes',
    '账单': 'Relevés financiers',
    '全部平仓': 'Fermer tout',
    '全部撤单': 'Annuler tout',

    '合约名称': 'Nom du contrat',
    '创建时间': 'Date de création',
    '方向': 'Direction',
    '杠杆': 'Effet de levier',
    '保证金': 'Marge',
    '开仓价格': 'Prix d ouverture',
    '开仓均价': 'Prix moyen d ouverture',
    '全仓风险率': 'Taux de risque en mode croisé',
    '预估爆仓价': 'Prix de liquidation estimé',
    '收益率': 'Taux de rendement',
    '平仓价格': 'Prix de clôture',
    '预计强平价': 'Prix de liquidation forcée estimé',
    '持仓数量': 'Quantité en position',
    '张': 'Contrat',
    风险率: 'Taux de risque',
    保证金率: 'Taux de marge',
    预计止盈价: 'Prix de take-profit estimé',
    预计止损价: 'Prix de stop-loss estimé',
    浮动盈亏: 'Profit/Perte flottant',
    平仓盈亏: 'Profit/Perte de clôture',
    盈亏: 'Profit/Perte',
    委托数量: 'Quantité ordonnée',
    委托价格: 'Prix ordonné',
    成交价格: 'Prix d exécution',
    成交均价: 'Prix moyen d exécution',
    止盈价: 'Prix de take-profit',
    止损价: 'Prix de stop-loss',
    执行价: 'Prix d exécution',
    触发条件: 'Condition de déclenchement',
    操作: 'Opération',
    手续费: 'Frais',
    平仓类型: 'Type de clôture',
    类型: 'Type',
    数量: 'Quantité',

    逐仓做多: 'Long isolée',
    逐仓做空: 'Short isolée',
    全仓做多: 'Long croisée',
    全仓做空: 'Short croisée',
    永续合约: 'Contrat perpétuel',

    手动平仓: 'Clôture manuelle',
    市价平仓: 'Clôture au prix du marché',
    限价平仓: 'Clôture à prix limite',
    止盈: 'Take-profit',
    止损: 'Stop-loss',
    手动撤销: 'Annulation manuelle',
    自动减仓: 'Réduction automatique',
    强制减仓: 'Réduction forcée',
    强制平仓: 'Clôture forcée',
    资金不足系统撤单: 'Annulation par le système pour fonds insuffisants',
    资金超限系统撤单: 'Annulation par le système pour fonds dépassés',
    撤单: 'Annuler',
    平仓: 'Clôturer',
    更多: 'Plus',
    部分平仓: 'Clôture partielle',
    反向开仓: 'Ouverture inverse',
    加仓: 'Ajouter',
    一键平仓: 'Fermer en un clic',
    最新价: 'Dernier prix',
    体验金平仓: 'Clôture en 24h',
    下单时间: 'Heure de commande',
    交易类型: 'Type de trading',
    委托类型: 'Type d ordre',
    成交类型: 'Type d exécution',
    逐仓平多: 'Fermer long isolée',
    逐仓开多: 'Ouvrir long isolée',
    逐仓平空: 'Fermer short isolée',
    逐仓开空: 'Ouvrir short isolée',
    全仓平多: 'Fermer long croisée',
    全仓开多: 'Ouvrir long croisée',
    全仓平空: 'Fermer short croisée',
    全仓开空: 'Ouvrir short croisée',
    可平量为0: 'Quantité clôturable = 0',
    激活价格: 'Prix d activation',
    状态: 'Statut',
    未激活: 'Non activé',
    已激活: 'Activé',
    回调率: 'Taux de rappel',
    仓位ID: 'ID du poste',
  };
  export const dialog = {
    前往设置: 'Aller aux paramètres',
    提示: 'Astuce',
    确定: 'CONFIRMER',
    取消: 'ANNULER',
    确认要全部平仓吗: 'Confirmer la clôture de tout au prix du marché et l annulation de tous les ordres ?',
    确认要全部撤单吗: 'Confirmer l annulation de tous les ordres ?',
    确认要一键平舱吗: 'Confirmer la fermeture en un clic ?',
    确认要一键平仓: 'Confirmer la fermeture en un clic et lafin de la copie ?',
    确认要市价平仓吗: 'Confirmer la clôture au prix du marché ?',
    确认要限价平舱吗: 'Confirmer la clôture à prix limite ?',
    需先设置总跟单账户:"Veuillez d'abord configurer le compte de copie global pour démarrer",
    加仓: 'Ajouter',
    不能为空: 'Ne peut pas être vide',
    必须为数字值: 'Doit être un nombre',
    数字不能小于等于0: 'Le nombre ne peut pas être ≤ 0',
    请输入正确的杠杆倍数: 'Veuillez entrer un effet de levier valide',
    无法切换仓位模式: 'Impossible de changer le mode de poste',
    当前账户没有权限: 'Le compte actuel n a pas l autorisation',
    swap001: 'Il y a des positions, impossible de changer le mode de poste',
    需全部平仓后可重新设置:"Impossible de modifier le montant et le多重 lors de positions copiées. Veuillez tout clôturer d'abord.",
    按张数: 'Par contrat',
    按金额: 'Par montant',
    按比例: 'Par proportion',
    按价格: 'Par prix',
    张: 'Contrat',
    预计加仓金额: 'Montant d ajout estimé',
    预计加仓张数: 'Contrats d ajout estimés',
    持仓数量: 'Quantité en position',
    开仓价格: 'Prix d ouverture',
    确认要反向开仓吗: 'Confirmer l ouverture inverse ?',
    预计平仓金额: 'Montant de clôture estimé',
    预计平仓比例: 'Proportion de clôture estimée',
    预计平仓张数: 'Contrats de clôture estimés',
    比例不可以大于: 'La proportion ne peut pas être supérieure à',
    比例不可以小于: 'La proportion ne peut pas être inférieure à',
    部分平仓: 'Clôture partielle',
    确认撤单吗: 'Confirmer l annulation ?',
    确认要平仓吗: 'Confirmer la clôture ?',
    盈亏: 'Profit/Perte',
    当前止损价: 'Prix de stop-loss actuel',
    预估止损价: 'Prix de stop-loss estimé',
    亏损: 'Perte',
    止损修改: 'Modifier le stop-loss',
    止损比例: 'Proportion stop-loss',
    止损价格: 'Prix stop-loss',
    当前盈利价: 'Prix de profit actuel',
    预估止盈价: 'Prix de take-profit estimé',
    收益: 'Profit',
    止盈修改: 'Modifier le take-profit',
    止盈比例: 'Proportion take-profit',
    止盈价格: 'Prix take-profit',
    请输入加仓数: 'Veuillez entrer le nombre à ajouter',
    请输入金额: 'Veuillez entrer le montant',
    请输入止盈价格: 'Veuillez entrer le prix de take-profit',
    请输入止盈比例: 'Veuillez entrer la proportion de take-profit',
    请输入止损价格: 'Veuillez entrer le prix de stop-loss',
    请输入止损比例: 'Veuillez entrer la proportion de stop-loss',

    'BTC/USDT账户模式': 'Mode BTC/USDT',
    账户模式: 'Mode de compte',
    调整仓位模式: 'Ajuster le mode de poste',
    保证金模式: 'Mode de marge',
    仓位模式: 'Mode de poste',
    调整保证金模式: 'Ajuster le mode de marge pour tous les contrats USDT',
    调整仓位合并模式: 'Ajuster le mode de fusion de poste pour tous les contrats USDT',
    全仓模式: 'Mode croisé',
    仓位合并: 'Fusion de postes',
    逐仓: 'Isolé',
    全仓: 'Croisé',
    合仓: 'Fusionner',
    分仓: 'Séparer',
    swap002:
      'En mode isolé, l utilisateur peut avoir des positions long et short. Les risques sont calculés indépendamment. En cas de liquidation, seule la marge du poste est perdue.',
    全仓模式下所有仓位将共享合约账户的可用保证金:
      'En mode croisé, tous les postes partagent la marge disponible du compte. En cas de liquidation forcée, tous les postes et la marge peuvent être perdus.',
    合仓提示: '',
    分仓提示: '',
    不再提示: 'Ne plus afficher',

    biking合约用户使用协议: 'Contrat d utilisation Biking',
    综述:
      '<b>1.概述</b><br><br>' +
      '<span>' +
      '1.1永续合约("本服务")是"biking"推出的虚拟资产衍生品。由"biking"负责产品的设计管理和交易平台的运营服务。' +
      '为使用"biking"永续合约，您应当阅读并遵守《"biking"永续合约用户使用协议》("本协议")。请您务必审慎阅读、充分理解各条款内容，并选择接受或不接受本协议。' +
      '<br><br>' +
      '1.2除非您已阅读并接受本协议所有条款，否则您无权使用"biking"永续合约及其相应的服务。您接受本协议的行为，以及您使用本服务的行为即视为您已阅读并同意受本协议的约束。' +
      '</span>' +
      '<br><br>' +
      '<b>2. 使用本服务的资格</b>' +
      '<br><br>' +
      '<span>2.1 您了解并确认：' +
      '<br>' +
      '您已同意遵守"biking服务条款"，同时您有资格并且不被禁止使用其中定义的"服务";' +
      '<br>' +
      '本协议与您所在国家或地区的法律没有冲突;' +
      '<br>' +
      '您是存入本服务的虚拟资产的合法所有者，并保证这些虚拟资产的来源是合法的。' +
      '<br><br>' +
      '2.2您了解使用本服务的风险，包括但不限于：' +
      '<br>' +
      '虚拟资产及其衍生品的高价格波动可能会在短时间内造成重大或全部损失；' +
      '</span>',
    我已阅读并同意上述协议: 'J ai lu et j accepte',

    调整杠杆: 'Ajuster l effet de levier',
    杠杆倍数: 'Multiple d effet de levier',
    当前杠杆倍数最大可开: 'Effet de levier actuel max :',
    '当前仓位所需保证金': 'Marge requise pour le poste actuel :',

    交易单位切换: 'Changer l unité de trading',
    成交类型切换: 'Changer le type d exécution',
    限价: 'Limite',
    市价: 'Marché',
    数字范围必须在: 'Le nombre doit être entre 1 et 100',
    请输入平仓数: 'Veuillez entrer le nombre à clôturer',
    请输入平仓比例: 'Veuillez entrer la proportion de clôture',
    请输入整数: 'Veuillez entrer un entier',
    以当前最优价格交易: 'Trading au meilleur prix actuel',
    请输入格式正确的杠杆倍数: 'Veuillez entrer un effet de levier valide',
    杠杆倍数提示: 'Effet de levier élevé, faites attention aux risques.',
    下单二次确认: 'Confirmation de commande',
    平仓二次确认: 'Confirmation de clôture',
    下单确认: 'Confirmer la commande',
    二次确认不展示: 'Ne plus afficher (redémarrable dans les préférences)',
    切换交易单位: 'Changer l unité de trading',
    偏好设置: 'Préférences',
    仓位止盈止损: 'Stop loss/take profit du poste',
    移动止盈止损: 'Stop loss/take profit mobile',
    止盈止损提示:
      'Le stop loss/take profit mobile est utilisé pour clôture. Quand le marché évolue favorablement et fait un pullback, l ordre est soumis au marché.',
    最新成交价: 'Dernier prix d exécution',
    设置止盈: 'Définir take-profit',
    设置止损: 'Définir stop-loss',
    预计盈利: 'Profit estimé',
    预计亏损: 'Perte estimée',
    调整保证金: 'Ajuster la marge',
    增加: 'Augmenter',
    减少: 'Réduire',
    最大: 'Maximum',
    当前仓位保证金: 'Marge du poste actuel',
    最大可增加: 'Maximum augmentable',
    最大可减少: 'Maximum réductible',
    调整后参考强评价: 'Prix de liquidation estimé après ajustement',
    请输入保证金: 'Veuillez entrer la marge',
    强平价格: 'Prix de liquidation',
    开仓数量: 'Quantité d ouverture',
    计算: 'Calculer',
    计算结果: 'Le résultat du calcul est uniquement参考',
    回调率: 'Taux de rappel',
    请输入回调率: 'Veuillez entrer le taux de rappel',
    仓位数量: 'Quantité du poste',
    激活价: 'Prix d activation',
    请输入激活价: 'Veuillez entrer le prix d activation',
    激活做多提示: 'Long doit être supérieur au dernier prix',
    激活做空提示: 'Short doit être inférieur au dernier prix',
  };
  export const codeInfo = {
    永续合约: 'Perpétuel',
    标记价格: 'Prix marqué',
    指数价格: 'Prix index',
    指数价格提示:
      'Le prix index en temps réel. Il est utilisé pour calculer le prix de liquidation estimée et peut différer du dernier prix pour éviter la manipulation.',
    '24H最高': 'Plus haut 24H',
    '24H最低': 'Plus bas 24H',
    资金费率: 'Taux de funding',
    距费用结算: 'Prochaine结算dans',
    我的赠金: 'Mes bonus',
  };
  export const panKou = {
    交易深度: 'Profondeur du marché',
    实时成交: 'Carnet d ordres',
    张: 'Contrat',
    保证金: 'Marge',
    价格: 'Prix',
    数量: 'Quantité',
    时间: 'Temps',
    累计: 'Cumulé',
  };
  export const placeOrder = {
    立即去玩:"Commencer maintenant",
    全仓: 'Croisé',
    逐仓: 'Isolé',
    杠杆: 'Levier',
    开多: 'Long',
    开空: 'Short',
    市价委托: 'Marché',
    限价委托: 'Limite',
    计划委托: 'Plan',
    价格: 'Prix',
    数量: 'Quantité',
    限价: 'Limite',
    市价: 'Marché',
    止盈止损: 'Stop/Take',
    张: 'Contrat',
    开仓价: 'Prix d ouverture',
    触发价: 'Prix de déclenchement',
    执行价: 'Prix d exécution',

    收益: 'Profit',
    按比例设置: 'Définir par proportion',
    按价格设置: 'Définir par prix',
    亏损: 'Perte',

    swap003: 'Acheter/Long',
    swap004: 'Vendre/Short',
    买入: 'Acheter',
    卖出: 'Vendre',
    做多: 'Long',
    做空: 'Short',
    可用: 'Disponible',
    可做多: 'Peut ouvrir long',
    可做空: 'Peut ouvrir short',

    资产: 'Actifs',
    持仓保证金: 'Marge en position',
    未实现盈亏: 'Profit/Perte non réalisé',
    净值: 'Valeur nette',
    可用保证金: 'Marge disponible',
    账户余额: 'Solde du compte',
    风险率: 'Taux de risque',

    合约信息: 'Info contrat',
    指数来源: 'Source de l index',
    合约面值: 'Valeur nominale du contrat',
    资金费率: 'Taux de funding',
    最大杠杆: 'Levier max',
    下单方向可开张数的: 'Nombre de contrats possibles dans la direction',

    立即注册: 'S inscrire',
    登录: 'Connexion',
    swap005: 'Actifs (Contrats perpétuels)',
    登录以查看: 'Connectez-vous pour voir',

    请输入数量: 'Veuillez entrer la quantité',
    请输入价格: 'Veuillez entrer le prix',
    请输入限价: 'Veuillez entrer le prix limite',
    请输入止盈止损: 'Veuillez entrer stop/take',
    '止损率不能大于90%': 'Le taux de stop-loss ne peut pas dépasser 90%',
    止损价格不能大于: 'Le prix de stop-loss ne peut pas être supérieur à',
    开通合约账号: 'Ouvrir un compte à terme',
    账号冻结: 'Compte gelé',
    '止盈率不能大于1000%': 'Le taux de take-profit ne peut pas dépasser 1000%',
    请输入触发价: 'Veuillez entrer le prix de déclenchement',
    保证金: 'Marge',
    体验金: 'Bonus',
    不使用体验金: 'Ne pas utiliser le bonus',
    查看详情: 'Voir les détails',
    委托保证金: 'Marge ordonnée',
    币: 'Jeton',
    计算器: 'Calculateur',
    划转: 'Transfert'
  };
  export const codelist = {
    搜索: 'Rechercher',
    全部: 'Tout',
    交易对: 'Paire de trading',
    最新价: 'Dernier prix',
    涨幅: 'Variation',
    自选: 'Favoris',
    添加自选成功: 'Ajouter aux favoris',
    取消自选成功: 'Retirer des favoris',
  };
  export const merchandiser = {
    我的实盘: "Mon compte réel",
    与优秀的交易员共同赚钱:"Gagner avec d'excellents traders",
    code_00051: "Communauté de copie",
    个人中心:'Centre personnel',
    更多服务:'Plus de services',
    钱包: "Portefeuille",
    衍生品:'Produits dérivés',
    跟单设置:'Paramètres de copie',
    跟单: 'Copie',
    跟单提示: 'Données mises à jour chaque heure',
    我的跟单: 'Ma copie',
    成为交易员: 'Devenir trader',
    综合排名: 'Classement global',
    收益率: 'Taux de rendement',
    近3周收益: '收益3 semaines',
    近3周胜率: 'Victoires sur 3 semaines',
    总收益: 'Profit total',
    累计收益率: 'Rendement cumulélibération cumulative',
    累计跟随人数: 'Nombre累计de suiveurs',
    跟随中: 'En cours de copie',
    AUM: 'AUM',
    当前跟谁: 'Copie actuelle',
    搜索交易员: 'Rechercher un trader',
    满员: 'Complet',
    申请成为交易员: 'Postuler comme trader',
    手机号: 'Numéro de téléphone',
    邮箱: 'Email',
    请输入邮箱: 'Veuillez entrer l email',
    邮箱错误: 'Veuillez entrer un email valide',
    请输入手机号: 'Veuillez entrer le téléphone',
    手机号错误: 'Veuillez entrer un téléphone valide',
    请输入正确数值: 'Veuillez entrer un montant valide',
    申请交易员提示文案: 'Postulez comme trader pour recevoir des commissions',
    跟单确认: 'Confirmation de copie',
    我已同意跟单协议: 'J ai lu et accepte le protocole de copie',
    跟单协议: '《Protocole de copie》',
    申请跟单提示文案: "Ce protocole est établi entre vous et Biking. L'utilisation de la plateforme signifie acceptation des termes.",
    申请跟单提示文案1: "1. Suivre un trader comporte des risques de perte.",
    申请跟单提示文案2: "2. Biking supporte le mode isolé pour la copie.",
    申请跟单提示文案3: "3. Après succès, seuls les nouvelles positions sont copiées.",
    申请跟单提示文案4: "4. Ajuster les positions pendant la copie Met fin au mode copie.",
    申请跟单提示文案5: "5. Les profits donnent droit à 12% pour le trader.",
    申请跟单提示文案6: "6. Attention aux risques.",
    申请跟单提示文案7: "7. En cas d'infraction, la copie est terminée.",
    申请跟单提示文案8: "8. Le trader peut retirer des suiveurs.",
    搜索您的国家名或国家区号: 'Rechercher votre pays ou indicatif',
    我已同意成为交易员: 'J accepte de devenir trader',
    请勾选: 'Veuillez cocher',
    申请交易员失败提示: 'Vous êtes en copie,veuillezen d abord.',
    我知道了: 'J ai compris',
    今日收益: 'Profit du jour',
    累计收益: 'Profit cumulélibération cumulative',
    交易员分成: 'Part du trader',
    待结算分成: 'Part en attente',
    已结算分成: 'Part réglée',
    当前跟单: 'Copie actuelle',
    历史跟单: 'Historique de copie',
    我的交易员: 'Mon trader',
    编辑: 'Modifier',
    平仓均价: 'Prix moyen de clôture',
    持仓均价: 'Prix moyen de position',
    开仓时间: 'Heure d ouverture',
    平仓时间: 'Heure de clôture',
    预估暴仓价: 'Prix de liquidation estimé',
    交易员: 'Trader',
    详情: 'Détails',
    仓位ID: 'ID du poste',
    空位提醒: 'Rappel de place',
    空位提醒内容: 'Le trader est complet. Vous serez notifié quand une place se libère.',
    当前跟随: 'Copie actuelle',
    跟随人数数据: '{v1}/{v2} personnes',
    跟随人数: 'Nombre de suiveurs',
    总权益: 'Droit total',
    带单合约: 'Contrat mené',
    交易数据: 'Données de trading',
    交易笔数: 'Nombre de trades',
    盈利笔数: 'Trades rentables',
    亏损笔数: 'Trades perdants',
    扛单比例: 'Ratio de tenue',
    平均扛单率: 'Taux moyen de tenue',
    最大扛单率: 'Taux max de tenue',
    订单: 'Ordre',
    跟随者: 'Suiveur',
    跟随者收益: 'Profit du suiveur',
    跟随用户: 'Utilisateur copié',
    跟随总额: 'Montant total copié',
    跟随收益: 'Profit de copie',
    交易员订单本金: 'Capital de l ordre du trader',
    当前带单: '，带单 actuel',
    历史带单: 'Historique带单',
    跟单数据统计: 'Statistiques de copie',
    不用了: 'Non merci',
    设置提醒成功: 'Rappel défini',
    我的带单: 'Ma带单',
    查看主页: 'Voir la page',
    利润分成比例: 'Part des profits',
    跟随交易员: 'Copier le trader',
    仓位类型: 'Type de poste',
    指定杠杆: 'Levier spécifié',
    请输入杠杆: 'Veuillez entrer le levier',
    单笔倍率: 'Multiplicateur unitaire',
    单笔金额: 'Montant unitaire',
    固定额度: 'Montant fixe',
    请输入单笔金额1: 'Veuillez entrer un montant fixe ≥5U',
    请输入单笔金额: 'Veuillez entrer le montant {v1}~{v2}',
    请输入单笔倍率: 'Veuillez entrer le比例 {v1}~{v2}',
    每次下单折合U: '每次开仓投入{v1}USDT保证金',
    每次下单倍数: '每次下单数量是交易员的{v1}倍',
    倍率: 'Multiplicateur',
    跟单本金: 'Capital copié',
    总跟单保证金: 'Marge totale copiée',
    请输入跟单本金: 'Veuillez entrer le capital copié',
    资产账户: 'Compte actifs {v1}USDT',
    合约账户: 'Compte contrat {v1}USDT',
    风险控制: 'Contrôle des risques',
    设置: 'Paramètres',
    保存: 'Enregistrer',
    取消跟随: 'Annuler la copie',
    移除跟随: 'Retirer la copie',
    交易员保证金: 'Marge du trader',
    请输入交易员保证金: 'Veuillez entrer la marge du trader',
    风险设置提示: '当持仓本金达到此数值将不再跟随',
    关闭带单: 'Fermer带单',
    我的跟随者: 'Mes suiveurs',
    带单设置: 'Paramètres带单',
    预计利润分成: 'Part de profit estimée',
    利润分成: 'Part des profits',
    开启成功: 'Ouverture réussie',
    开启失败: 'Échec de l ouverture',
    关闭成功: 'Fermeture réussie',
    关闭失败: 'Échec de la fermeture',
    确认取消吗: 'Confirmer l annulation ?',
    条件一: 'Pas de position, ordre ou plan',
    条件二: 'Solde du compte contrat ≥{v}USDT',
    条件三: 'Pas de position',
    最大回撤: 'Drawdown max',
    平均持仓时间: 'Temps moyen de position',
    正在跟随: 'En cours',
    历史跟随: 'Historique',
    累计跟单: 'Copie累计',
    累计分成: 'Part累计',
    笔: 'trade',
    上一页: 'Page précédente',
    下一页: 'Page suivante',
    返回: 'Retour',
    今日预估收益: 'Profit estimé du jour',
    账户权益: 'Droits du compte',
    将账户权益展示在个人信息页面: 'Afficher les droits sur la page profil',
    带单本金: 'Capital带单',
    每次开仓均会展示带单本金: '每次开仓显示带单本金',
    隐藏挂单价:'Cacher le prix limité',
    带单币对: 'Paire带单',
    入住时间: 'Date d admission',
    保存成功: 'Enregistré',
    取消成功: 'Annulé',
    设置成功: 'Paramétré',
    跟单合约: 'Contrat copié',
    历史委托: 'Historique des ordres',
    成交数量: 'Quantité exécutée',
    触发时间: 'Temps de déclenchement',
    开启带单: 'Démarrer带单',
    账户已冻结: 'Compte gelé,veuillez contacter le support',
    审核中: 'En attente',
    小时: '{v} heures',
    累计分润: 'Bénéfice累计',
    今日预估分润: 'Bénéfice estimé du jour',
    交易协议: '《Protocole de trading》',
    带单协议: '《Protocole带单》',
    追加跟单本金: 'Ajouter du capital copié',
    提示: 'Astuce :',
    提示信息: 'Le bénéficie est calculé每日0点并1点前发放',
    合约跟单: 'Copie de contrats',
    跟单文字: 'Avec Biking, gagnez avec les meilleurs traders',
    查看牛人实盘: 'Voir les traders performants',
    捕捉市场信号: 'Saisir les signaux du marché',
    复制高手收益: 'Copier les experts',
    跟单指南: 'Guide de copie',
    跟单广场: 'Place de copie',
    跟单总收益: 'Profit total de copie',
    丰厚分润收入: 'Revenus de partage',
    更多平台曝光: 'Plus de visibilité',
    专属交易徽章: 'Badge exclusif',
    成为Biking带单交易员: 'Devenez trader带单 Biking',
    享受Biking带单交易员的独家福利: 'Profitez des avantages exclusifs',
    平台奖励: '12% de分享',
    联系方式: 'Coordonnées',
    简介: 'Biographie',
    请输入简介: 'Veuillez entrer la biographie',
    交易能力证明: 'Preuve de capacité de trading',
    选择周期: 'Veuillez sélectionner un周期>30天',
    我已阅读并同意: 'J ai lu et j accepte',
    跟单交易服务条款: '《Conditions du service de copie》',
    立即申请: 'Postuler maintenant',
    请输入联系方式: 'Veuillez entrer les coordonnées',
    联系方式不正确: 'Coordonnées incorrectes !',
    邮箱格式不正确: 'Format email incorrect',
    请输入简介信息: 'Veuillez entrer la biographie',
    请确认勾选协议: 'Veuillez cocher pour accepter',
    上传头像图片限制: 'Image max 10MB !',
    最大限制: 'Maximum 3 fichiers',
    带单交易员招募中: 'Recrutement de traders带单',
    跟单成功: 'Copie réussie',
    昵称: 'Pseudonyme',
    请输入昵称: 'Veuillez entrer le pseudonyme',
    申请交易员已提交: 'Demande soumise,veuillezen attente'
  };
  export const hyy = {
    bkt: "Ne pas ouvrir",
    wqdkt: "Je confirme",
    kt12: "1. Veuillez bien comprendre les基础知识和风险",
    kt13: "2. Ce提示ne liste pas tous les risques",
    kt14: "3. Investissez selon votre capacité",
    kt0: "Cher utilisateur :",
    kt1: "Vous n'avez pas encore de compte contrat,veuillezlire attentivement :",
    kt2: "Si le prix évolue contre vous, Biking liquidera votre position.",
    kt3: "Veuillez lire et respecter les règles.",
    kt4: "Les profits et pertes fluctuent avec le marché.",
    kt5: "Dans certains cas extrêmes,vous pourriez ne pas pouvoir fermer vos positions.",
    kt6: "Les réglementation peuvent affecter vos positions.",
    kt7: "Les cas de force majeure peuvent causer des pertes.",
    kt8: "La couverture a les mêmes risques que la spéculation.",
    kta9: "Si vous n'avez pas fait KYC ou lié Google,la sécurité peut être affectée",
    kta10:
      "Dans certains cas extrêmes,vous pourriez ne pas pouvoir fermer vos positions.",
    kt9: "J'ai lu et j'accepte les risques",
    kt10: "Ouvrir le compte à terme",
    zjhz: "Transfert de fonds",
    ljhz: "Transférer maintenant",
    qx: "Annuler le transfert",
    khz: "Transférable",
    qxz: "Veuillez sélectionner",
    bz: "Jeton",
    c: "De",
    zz: "Vers",
    sl: "Quantité",
    qb: "Tout",
    ktcg: "Ouverture réussie",
    ktsb: "Échec de l'ouverture",
    hzcg: "Transfert réussi",
    hzsb: "Échec du transfert",
    wyyd: "",
    tc: "Quitter",
    warning1: "Veuillez sélectionner un jeton",
    warning2: "Le compte source ne peut pas être vide",
    warning3: "Le compte cible ne peut pas être vide",
    warning4: "Veuillez entrer un montant ≤ disponible",
    gb: "Fermer",
    openSuccess: "Vous avez ouvert le trading à terme",
    openSuccessTip: "Veuillez transférer des fonds vers le compte contrat",
    warning5: "Max 4 décimales",
    not_get_nm: "L'activité est terminée,vous n'avez pas reçu le泥码",
  }

  export const invite = {
    yqfy: "Commission d'invitation",
    yj1: "Partager le lien, l'affiche ou le code",
    yj2: "Inviter des amis à s'inscrire et trader",
    yj3: "Profiter des commissions",
    yqm: "Mon code d'invitation :",
    yqlj: "Mon lien d'invitation :",
    fz: "Copier",
    fzcg: "Copié",
    fzsb: "Échec",
    dlck: 'Connectez-vous pour voir',
    rs: "Personnes invitées",
    ljbb: "Commission spot累计({flag})",
    ljeft: "Commission ETF累计({flag})",
    ljhy: "Commission contrats累计({flag})",
    yhm: "Nom d'utilisateur",
    sfsm: "Vérifié ?",
    tjsj: "Date d'invitation",
    zsy: "Profit total({flag})",
    s: "Oui",
    f: "Non",
    djjz: "Charger plus",
    ckmx: "Voir détails",
    pm: "Rang",
    zyqr: "Invitations月",
    zfyj: "Commission月({flag})",
    ckbd: "Voir le classement complet",
    rlues1: "Invitez et gagnez des commissions long terme.",
    rlues2:
      "Établissez une relation d'invitation avec vos amis et gagnez des commissions sur leurs trades.",
    rlues3: "Règles et taux de commission",
    jylx: "Type de trading",
    yqrfy: "Commission de l'inviteur",
    yqgxyxq: "Validité de la relation",
    sixMonth: "6 mois",
    yj: "Illimité",
    bbjy: "Trading spot",
    hyjy: "Trading à terme",
    etfjy: "Trading ETF à effet de levier",
    gxsj: "Mise à jour chaque lundi",
    xts: "Astuce",
    ts1: "L'ami doit entrer votre code d'invitation !",
    ts2: "Scannez le QR code pour inviter rapidement.",
    tgzsy: "Profit total推广({flag})",
    cz: "Opération",
    fymx: "Détails commission >",
    zwsj: "Aucun enregistrement",
    yh: "Utilisateur",
    hqyj: "Commission reçue",
    ysm: "Vérifié",
    wsm: "Non vérifié",
    hyfymx: "Détails commission amis",
    fylx: "Type de commission",
    fyje: "Montant de commission",
    fysj: "Date de commission",
    mxsyb: "Tableau des profits",
    zwjy: "Cet ami n'a pas encore tradé",
    bczxc: "Enregistrer",
    rlues4: "Due aux网络fluctuations,des retards peuvent survenir.",
    moreRules: "Voir règles détaillées",
  };


// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/fr.js